/**
 * The sticky header's renderer-fixed height in px (PRD §12): every band's
 * `scroll-margin-top`, so a `ScrollToBlockAction` target is never covered.
 */
export const CAMPAIGN_HEADER_HEIGHT = 64
